import { render, staticRenderFns } from "./CompetenceCommentTableColumn.vue?vue&type=template&id=174179da&scoped=true"
import script from "./CompetenceCommentTableColumn.vue?vue&type=script&lang=js"
export * from "./CompetenceCommentTableColumn.vue?vue&type=script&lang=js"
import style0 from "./CompetenceCommentTableColumn.vue?vue&type=style&index=0&id=174179da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "174179da",
  null
  
)

export default component.exports